import { get} from './http';

export const getUserInfo = async (data = {}) => await get('/api/common/get-user-info', data);
export const getProductList = async (data = {}) => await get('/api/common/get-product-list', data);
export const getStaffByDept = async (data = {}) => await get('/api/common/get-staff-bydept', data);